import React, { useState } from 'react';
import { Container, Button, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import NavbarComponent from '../../components/NavbarComponent';
import FooterComponent from '../../components/FooterComponent';
import { FaBook, FaCompass } from 'react-icons/fa';
import styled from 'styled-components';

// Styled components for cards
const OptionCard = styled(Card)`
  display: flex;
  align-items: center;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 15px;
  background-color: ${props => (props.selected ? '#2ECC71' : '#1E1E1E')};
  color: ${props => (props.selected ? '#fff' : '#fff')};
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    transform: scale(1.02);
  }
`;

const OptionIcon = styled.div`
  font-size: 28px;
  margin-right: 15px;
`;

const OptionText = styled.div`
  flex: 1;
  font-size: 18px;
  font-weight: bold;
`;

const FindMySkillLevelStep2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCourse = location.state?.selectedCourse || { coursename: "this course" };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (!selectedOption) {
      alert('Please select an option before continuing.');
      return;
    }
    // Navigate to GetReadySkillTest
    navigate('/get-ready-skill-test', { state: { selectedCourse, selectedOption } });
  };

  return (
    <>
      <NavbarComponent />

      <Container className="text-center my-5">
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#2ECC71' }}>Where would you like to start?</h2>

        <OptionCard onClick={() => handleOptionSelect("start_from_scratch")} selected={selectedOption === "start_from_scratch"}>
          <OptionIcon><FaBook /></OptionIcon>
          <OptionText>
            Start from scratch
            <p style={{ fontSize: '14px', fontWeight: 'normal', margin: 0 }}>Take the easiest lesson of the {selectedCourse.coursename} course</p>
          </OptionText>
        </OptionCard>

        <OptionCard onClick={() => handleOptionSelect("find_my_level")} selected={selectedOption === "find_my_level"}>
          <OptionIcon><FaCompass /></OptionIcon>
          <OptionText>
            Find my level
            <p style={{ fontSize: '14px', fontWeight: 'normal', margin: 0 }}>Let FinTorro recommend where you should start learning</p>
          </OptionText>
        </OptionCard>

        {/* ✅ Continue Button */}
        <Button
          onClick={handleContinue}
          style={{
            backgroundColor: selectedOption ? '#FF7C24' : '#ccc',
            borderColor: selectedOption ? '#FF7C24' : '#ccc',
            fontSize: '18px',
            fontWeight: 'bold',
            borderRadius: '10px',
            padding: '12px 30px',
            marginTop: '20px',
            cursor: selectedOption ? 'pointer' : 'not-allowed',
          }}
          disabled={!selectedOption}
        >
          Continue
        </Button>
      </Container>

      <FooterComponent />
    </>
  );
};

export default FindMySkillLevelStep2;
